module.exports = __webpack_public_path__ + "static/img/pin-multi-inactive.cda07df.svg";